import React from 'react'

import { AudienceAppComponent } from '../WebinarAudienceRoom/components/AudienceAppComponent/AudienceAppComponent'
import { AudienceAppStateProvider } from '../WebinarAudienceRoom/providers/AudienceAppStateProvider'

const WebinarAudienceRoomRoutesComponent = () => {
  return (
    <AudienceAppStateProvider
      liveId={window.LIVE_ID}
      liveToken={window.LIVE_TOKEN}
    >
      <AudienceAppComponent />
    </AudienceAppStateProvider>
  )
}

export { WebinarAudienceRoomRoutesComponent }
